<app-navigation-panel-container>

  <!-- Main navigation panel -->
  <app-navigation-panel [expanded]="sideMenuExpanded" (onDragDismiss)="toggleSideMenu()">

    <div>
      <div class="flex items-center gap-x-2 pr-4">
        <div class="flex-1 px-3 py-1">
          <img
            src="assets/logos/logo-white.png"
            alt="Blume Logo"
            class="h-16"
          />
        </div>
        <app-icon-button
          class="lg:hidden"
          [config]="{
          icon: 'chevron-back-outline',
          color: 'surface',
          size: 'sm',
          border: true,
          shadow: true,
        }"
          (click)="toggleSideMenu()"
        ></app-icon-button>
      </div>
    </div>
    <div class="px-4">
      <app-wavy-divider class="block"></app-wavy-divider>
    </div>

    <!-- My Blume Section -->
    <div class="px-2 pt-2">
      <div class="px-4 pb-2">
        <div class="text-xs font-bold text-[var(--ion-color-medium)]">
          My Blume
        </div>
      </div>
      <div class="space-y-2">
        @for (item of myBlumeMenuItems; track $index) {
        <button
          appHapticFeedback
          class="!w-full !flex !items-center !text-left !justify-start !gap-x-4 !px-4 !py-3 !cursor-pointer !rounded-full !border-2 !border-transparent border-box"
          [ngClass]="{
      'theme-shadow !border-[var(--ion-color-dark)]': isActive(item.route),
      '!border-transparent': !isActive(item.route),
      'hover:bg-[var(--ion-color-light-shade)]': !isActive(item.route),
      'bg-[var(--ion-color-blue-tint)]': isActive(item.route) && item.color === 'blue',
      'bg-[var(--ion-color-yellow-tint)]': isActive(item.route) && item.color === 'yellow',
      'bg-[var(--ion-color-green-tint)]': isActive(item.route) && item.color === 'green',
      'bg-[var(--ion-color-red-tint)]': isActive(item.route) && item.color === 'red',
      'bg-[var(--ion-color-purple-tint)]': isActive(item.route) && item.color === 'purple',
      'bg-[var(--ion-color-orange-tint)]': isActive(item.route) && item.color === 'orange',
      'bg-[var(--ion-color-pink-tint)]': isActive(item.route) && item.color === 'pink',
      'bg-[var(--ion-color-teal-tint)]': isActive(item.route) && item.color === 'teal',
      'bg-[var(--ion-color-violet-tint)]': isActive(item.route) && item.color === 'violet',
      'bg-[var(--ion-color-surface-tint)]': isActive(item.route) && item.color === 'surface',
      'bg-[var(--ion-color-dark-tint)]': isActive(item.route) && item.color === 'dark',
    }"
          (click)="navigateTo(item.route)"
        >
          <div class="flex-shrink-0">
            <app-icon
              [name]="item.icon"
              size="sm"
              [color]="isActive(item.route) ? 'dark' : 'medium'"
            />
          </div>
          <div class="flex-1">
            <div class="font-semibold">{{ item.label }}</div>
            <div
              class="text-xs"
              [ngClass]="{
                'opacity-80': isActive(item.route),
                'text-medium': !isActive(item.route)
              }"
            ></div>
          </div>
        </button>
        }
      </div>
    </div>

    <!-- Admin Section -->
    @if (canViewAdminSection) {
    <div class="px-2 pt-6">
      <div class="px-4 pb-2">
        <div class="text-xs font-bold text-[var(--ion-color-medium)]">
          Admin
        </div>
      </div>
      <div class="space-y-2">
        @for (item of adminMenuItems; track $index) {
        <button
          appHapticFeedback
          class="!w-full !flex !items-center !text-left !justify-start !gap-x-4 !px-4 !py-3 !cursor-pointer !rounded-full !border-2 !border-transparent border-box"
          [ngClass]="{
      'theme-shadow !border-[var(--ion-color-dark)]': isActive(item.route),
      '!border-transparent': !isActive(item.route),
      'hover:bg-[var(--ion-color-light-shade)]': !isActive(item.route),
      'bg-[var(--ion-color-blue-tint)]': isActive(item.route) && item.color === 'blue',
      'bg-[var(--ion-color-yellow-tint)]': isActive(item.route) && item.color === 'yellow',
      'bg-[var(--ion-color-green-tint)]': isActive(item.route) && item.color === 'green',
      'bg-[var(--ion-color-red-tint)]': isActive(item.route) && item.color === 'red',
      'bg-[var(--ion-color-purple-tint)]': isActive(item.route) && item.color === 'purple',
      'bg-[var(--ion-color-orange-tint)]': isActive(item.route) && item.color === 'orange',
      'bg-[var(--ion-color-pink-tint)]': isActive(item.route) && item.color === 'pink',
      'bg-[var(--ion-color-teal-tint)]': isActive(item.route) && item.color === 'teal',
      'bg-[var(--ion-color-violet-tint)]': isActive(item.route) && item.color === 'violet',
      'bg-[var(--ion-color-surface-tint)]': isActive(item.route) && item.color === 'surface',
      'bg-[var(--ion-color-dark-tint)]': isActive(item.route) && item.color === 'dark',
    }"
          (click)="navigateTo(item.route)"
        >
          <div class="flex-shrink-0">
            <app-icon
              [name]="item.icon"
              size="sm"
              [color]="isActive(item.route) ? 'dark' : 'medium'"
            />
          </div>
          <div class="flex-1">
            <div class="font-semibold">{{ item.label }}</div>
            <div
              class="text-xs"
              [ngClass]="{
                'opacity-80': isActive(item.route),
                'text-medium': !isActive(item.route)
              }"
            ></div>
          </div>
        </button>
        }
      </div>
    </div>
    }

  </app-navigation-panel>

  <!-- Main content -->
  <app-navigation-panel-tabs-container [sideMenuExpanded]="sideMenuExpanded">
    <ion-tabs></ion-tabs>
  </app-navigation-panel-tabs-container>

</app-navigation-panel-container>
